import { Outlet } from "react-router-dom";

import { ErrorHeader } from "src/core/components/layout/ErrorHeader";
import { PageBreadcrumb } from "src/core/components/layout/PageBreadcrumb";

export const ErrorLayout = () => {
  return (
    <div className="layout-container">
      {/* On ne peut pas utiliser useBrand ici (cf AppRoutes.tsx) */}
      <ErrorHeader />
      <div className="w-full h-header bg-primary-faded border-y border-border"></div>
      <PageBreadcrumb className="mb-60 mt-15 ml-40" />
      <Outlet />
    </div>
  );
};
